import { FC } from 'react';

import EditIncentivesMarketSharePurchaseContractTemplateModalBody from './components/EditIncentivesMarketSharePurchaseContractTemplateModalBody';
import EditIncentivesMarketSharePurchaseContractTemplateModalFooter from './components/EditIncentivesMarketSharePurchaseContractTemplateModalFooter';
import EditIncentivesMarketSharePurchaseContractTemplateModalHeader from './components/EditIncentivesMarketSharePurchaseContractTemplateModalHeader';

const EditIncentivesMarketSharePurchaseContractTemplateModal: FC = () => (
  <>
    <EditIncentivesMarketSharePurchaseContractTemplateModalHeader />
    <EditIncentivesMarketSharePurchaseContractTemplateModalBody />
    <EditIncentivesMarketSharePurchaseContractTemplateModalFooter />
  </>
);

export default EditIncentivesMarketSharePurchaseContractTemplateModal;
